// authActions.js


export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_VERIFICATION_SUCCESS = 'LOGIN_VERIFICATION_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const UPDATE_TOKENS ='UPDATE_TOKENS';
export const SET_REFRESHING = 'SET_REFRESHING';
export const LOGOUT = 'LOGOUT';
export const USER_UPDATE = 'USER_UPDATE';

// Action for login request
export const loginRequest = () => ({
  type: LOGIN_REQUEST
});

// Action for successful login, storing access and refresh tokens
export const loginSuccess = () => ({
  type: LOGIN_SUCCESS,
});

export const verificationSuccess = ({ id,clinicId,roles,profileImage,clinicLogo,name }) => ({
  type: LOGIN_VERIFICATION_SUCCESS,
  payload: { id ,clinicId,roles,profileImage,clinicLogo,name}
});
// Action for failed login
export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error
});

export const updateProfileData = ({ newProfileImage,newClinicLogo,newName }) => ({
  type: USER_UPDATE,
  payload: { newProfileImage,newClinicLogo,newName },
});


// Action for logging out
export const logout = () => ({
  type: LOGOUT
});


